interface RatingBadgeProps {
  value: number;
  size?: "sm" | "md";
}

export default function RatingBadge({ value, size = "md" }: RatingBadgeProps) {
  const pad = size === "sm" ? "px-1.5 py-0.5 text-xs" : "px-2 py-1 text-sm";
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-md bg-accent-500 font-display font-semibold text-foreground-950 ${pad}`}
    >
      <i className="ri-star-fill text-xs" />
      {value.toFixed(1)}
    </span>
  );
}